import EditNewsAPI from "./editNewsAPI";

const EditNewsService = async (id: string, data: any): Promise<any> => {
  try {
    return await EditNewsAPI(id, data);
  } catch (error) {
    throw error;
  }
};

export default EditNewsService;